import { FilterCatalogActions } from "@/components/tradeideas/filter-catalog-actions";
import { FilterCatalogTable } from "@/components/tradeideas/filter-catalog-table";
import {
  TradeIdeasEmpty,
  TradeIdeasError,
  TradeIdeasPage,
} from "@/components/tradeideas/tradeideas-page";
import {
  useRefreshTradeIdeasFilterCatalog,
  useTradeIdeasFilterCatalogSeed,
  useTradeIdeasFilters,
} from "@/hooks/tradeideas/useTradeIdeasBot";

export default function TradeIdeasFiltersPage() {
  const filtersQ = useTradeIdeasFilters();
  const seedQ = useTradeIdeasFilterCatalogSeed();
  const refreshCatalog = useRefreshTradeIdeasFilterCatalog();
  const filters = filtersQ.data ?? [];

  return (
    <TradeIdeasPage
      title="TradeIdeas Filters"
      description="Catalog of known Trade Ideas columns, formulas, aliases, and units."
    >
      <div className="space-y-4">
        <FilterCatalogActions
          seed={seedQ.data}
          pending={refreshCatalog.isPending}
          onRefresh={() => refreshCatalog.mutate()}
        />
        {filtersQ.isError ? (
          <TradeIdeasError message={(filtersQ.error as Error).message} />
        ) : filtersQ.isLoading && filters.length === 0 ? (
          <TradeIdeasEmpty message="Loading filter catalog..." />
        ) : filters.length === 0 ? (
          <TradeIdeasEmpty message="No filter catalog entries found." />
        ) : (
          <FilterCatalogTable filters={filters} />
        )}
      </div>
    </TradeIdeasPage>
  );
}
